/* @flow */
import ms from 'ms';
import { List } from 'immutable';
import { getterFromKeyPath } from 'trustar/utils';
import { createSelector } from 'reselect';

import { adminRole } from '../profile/getters';
import type { LastViewed } from './types';
import {
  LAST_VIEWED_SEARCH,
  LAST_VIEWED_REPORTS,
  LAST_VIEWED_INDICATORS,
} from './constants';

export const intendedPath = getterFromKeyPath(['app', 'intendedPath']);

export const loading = getterFromKeyPath(['app', 'loading']);

const serverTimeout = getterFromKeyPath(['app', 'serverTimeout']);

export const timeoutWarning = getterFromKeyPath(['app', 'timeoutWarning']);

export const options = getterFromKeyPath(['app', 'options']);

export const isLoggedIn = getterFromKeyPath(['app', 'isLoggedIn']);

export const mfa = getterFromKeyPath(['app', 'mfa']);

export const passwordValidation = getterFromKeyPath(['app', 'passwordValidation']);

export const createPasswordAttempt = getterFromKeyPath(['app', 'createPasswordAttempt']);

export const userCredentials = getterFromKeyPath(['app', 'userCredentials']);

export const statusMessage = getterFromKeyPath(['app', 'statusMessage']);

export const loadingLogin = getterFromKeyPath(['app', 'loadingLogin']);

export const didAcceptTerms = getterFromKeyPath(['app', 'didAcceptTerms']);

export const confirmation = getterFromKeyPath(['app', 'confirmation']);

export const theme = getterFromKeyPath(['app', 'options', 'theme']);

export const visitedDashboard = getterFromKeyPath(['app', 'activity', 'visitedDashboard']);

export const visitedConstellation = getterFromKeyPath(['app', 'activity', 'visitedConstellation']);

export const visitedExplore = getterFromKeyPath(['app', 'activity', 'visitedExplore']);

export const routeHistory = getterFromKeyPath(['app', 'routeHistory']);

export const clipboardCopied = getterFromKeyPath(['app', 'clipboardCopied']);

/* Get last visited route (-2 => 1 before current = 'last' visited route) */
export const lastRoute = createSelector(
  routeHistory,
  (routes: List<string>): string => routes.get(-2, '')
);

/*
 * Determine if the user last viewed search, reports, or indicators, in the Explore view, in order to
 * correctly paginate graph.
 */

export const userLastViewed = createSelector(
  routeHistory,
  (routes: List<string>): LastViewed | null => {
    return routes.reverse().reduce((last, route) => {
      if (last) return last;
      if (route.includes('browse/search')) return LAST_VIEWED_SEARCH;
      if (route.includes('browse/reports')) return LAST_VIEWED_REPORTS;
      if (route.includes('browse/iocs')) return LAST_VIEWED_INDICATORS;
      return null;
    }, null);
  }
);

export const serverTime = createSelector(
  serverTimeout,
  (time: number): number => Math.max(time - ms('1m'), ms('3m')),
);

export const logoutTime = createSelector(
  serverTimeout,
  (time: number): number => Math.max(time - ms('2m'), ms('2m')),
);

export const warningTime = createSelector(
  serverTimeout,
  (time: number): number => Math.max(time - ms('3m'), ms('1m')),
);

// Color palette for theme dependent colors for the App Header
export const getHeaderPalette = createSelector([theme, adminRole], (theme, adminRole) => ({
  logoFill: theme === 'dark' ? 'white' : '#3568D5',
  iconFill: theme === 'dark' ? 'white' : '#979BA6',
}));

// Color palette for theme dependent colors for anything else
export const getRegularPallette = createSelector(theme, theme => ({
  logoFill: 'white',
  iconFill: 'black',
}));



// WEBPACK FOOTER //
// ./src/app/modules/app/getters.js